import React from "react";
import {Button, Input, Modal, Form} from "antd";
import {ModalProps} from "antd/lib/modal";
import {FormInstance} from "antd/lib/form";

interface ModifyModalProps extends ModalProps {
    form: FormInstance
}

export default function SalesTaxGroupEditModal(props: ModifyModalProps) {

    const {form, ...otherProps} = props

    return (
        <Modal {...otherProps}>
            <Form form={form} layout={'vertical'}>
                <Form.Item name={'id'} noStyle>
                    <Input style={{display: 'none'}}/>
                </Form.Item>
                <Form.Item label={'销售税组'} name={'salesTaxGroup'} required={true}>
                    <Input/>
                </Form.Item>
                <Form.Item label={'描述'} name={'desc'} required={true}>
                    <Input/>
                </Form.Item>
            </Form>
        </Modal>
    )
}
